<div style="padding:2%;">
    <div>
        <img style="width:10%;" src="../../../../assets/Solv_Logo_new.svg">
    </div>
    <div class="inter-semibold sp-top-margin-50" style="font-size: 38px;">
        You can’t find something if it doesn’t exists
    </div>
    <div class="inter-regular sp-font-size-32 sp-top-margin-30">
        We Apologise!
    </div>
    <div class="sp-top-margin-45 flex-align-item pointer-class" (click)="navigateToHome()">
        <div class="inter-medium sp-font-size-24 sp-right-margin-30">Or we can take you back</div>
        <div class="btn inter-medium sp-font-size-24">Home →</div>
    </div>
    <div style="display: flex; justify-content: flex-end;">
        <img style="width:40%;" src="../../../../assets/images/404.svg">
    </div>
</div>